import React from 'react';
import './index.css';
import {styled} from "../../styles/stitches.config";
import {EASE_COLORS} from '../../constants/colors';

const Div = styled('div', {
    height: '100vh',
    width: '100vw',
    display: 'flex',
    background: 'transparent',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
})

const PageLoader: React.FC = () => {
    return (
        <Div>
            <div
                className="spinnerContainer"
            >
                <svg
                    className="spin"
                    id="Layer_1"
                    data-name="Layer 1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 120 120"
                >
                    <path
                        className="circle"
                        d="M60,7.5A52.5,52.5,0,1,1,7.5,60,52.56,52.56,0,0,1,60,7.5M60,0a60,60,0,1,0,60,60A60,60,0,0,0,60,0Z"
                    >
                        <stop offset="2%" stopColor="#ffffff"/>
                        <stop offset="50%" stopColor="#ccc3f3"/>
                        <stop offset="98%" stopColor="#ccc3f3"/>
                    </path>
                    <path
                        className="piece"
                        d="M116.05,59h0a3.78,3.78,0,0,1-3.74-3.49A52.28,52.28,0,0,0,99,24.93a3.74,3.74,0,0,1,.17-5.13l0,0a3.77,3.77,0,0,1,5.48.18,59.81,59.81,0,0,1,15.09,35A3.73,3.73,0,0,1,116.05,59Z"
                    />

                </svg>
                <h6 style={{marginTop: '1rem', textAlign: 'center', color: EASE_COLORS.TEXT_SUBDUED}}> Loading...</h6>
            </div>
        </Div>
    );
};

export default PageLoader;
